/* eslint-disable react-hooks/rules-of-hooks */
import { useContext, useState, useEffect } from 'react';
import { ChatsNotificationsContext } from './context';
import { getUnreadMessages, Notifications } from './internal';

/* istanbul ignore next */
const noop = () => {};

export function useChatsNotifications() {
  const context = useContext(ChatsNotificationsContext);
  const [notificationsCount, setNotifications] = useState<number | null>(null);

  if (!context) {
    return null;
  }

  const { httpApi, logger, socket } = context;

  useEffect(() => {
    getUnreadMessages(httpApi, logger)
      .then(setNotifications)
      /* istanbul ignore next */
      .catch(noop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const notifications = new Notifications(socket, httpApi, logger);

    notifications
      .connect()
      .then(() => notifications.onNotifications(setNotifications))
      /* istanbul ignore next */
      .catch(noop);

    return () => {
      notifications.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return notificationsCount;
}
